module.exports = __webpack_public_path__ + "static/media/18.10e5176a.JPG";